var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "#C6C0CC",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2859 0.463135H11.4289C11.2395 0.463177 11.0579 0.538467 10.924 0.672434L0.209981 11.3864C-0.0691264 11.6652 -0.0693775 12.1174 0.209437 12.3965C0.209605 12.3967 0.209814 12.3969 0.209981 12.3971L8.06689 20.254C8.34583 20.5328 8.79795 20.5328 9.07685 20.254L19.7908 9.54002C19.925 9.40592 20.0003 9.224 20.0001 9.03432V1.17741C20.0001 0.782922 19.6804 0.463135 19.2859 0.463135ZM15.0003 6.89153C14.2113 6.89153 13.5717 6.25195 13.5717 5.46301C13.5717 4.67407 14.2113 4.03449 15.0003 4.03449C15.7892 4.03449 16.4288 4.67407 16.4288 5.46301C16.4288 6.25195 15.7892 6.89153 15.0003 6.89153Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "translate(0 0.463135)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeIcon);
export default __webpack_public_path__ + "static/media/badge-icon.d2fe3a3b.svg";
export { ForwardRef as ReactComponent };